import { render, staticRenderFns } from "./ZnZhaopin.vue?vue&type=template&id=2a8ef5cb&scoped=true&"
import script from "./ZnZhaopin.vue?vue&type=script&lang=js&"
export * from "./ZnZhaopin.vue?vue&type=script&lang=js&"
import style0 from "../../../company/statistics/css/fullCompanyDetail.css?vue&type=style&index=0&id=2a8ef5cb&scoped=true&lang=css&"
import style1 from "../../../company/statistics/css/commonCompany.css?vue&type=style&index=1&id=2a8ef5cb&scoped=true&lang=css&"
import style2 from "./ZnZhaopin.vue?vue&type=style&index=2&lang=css&"
import style3 from "./ZnZhaopin.vue?vue&type=style&index=3&id=2a8ef5cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8ef5cb",
  null
  
)

export default component.exports